:host([hidden='true']) {
  display: none;
}

.ux-checkbox-list-item {
  display: block;
  margin-bottom: 10px;
}